'use client';

import { styled } from '@linaria/react';
import { PopTopicListData } from '@fe-news/constants/pop-topic/type';
import Timeline from '@fe-news/components/atoms/PopTopic/Timeline';

const Container = styled.div`
  width: 100%;
  background: white;
  position: relative;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  &::before {
    content: '';
    position: absolute;
    left: 5px;
    height: 100%;
    border-left: 2px dotted rgba(84, 181, 198, 0.5);
    z-index: 0;
  }
`;

interface ListProps {
  data: PopTopicListData[];
}

const List: React.FC<ListProps> = ({ data }) => {
  return (
    <Container>
      {data.map((item, index) => {
        return <Timeline data={item} key={index} />;
      })}
    </Container>
  );
};

export default List;
